/**
 * Project 命名空间常量
 * 用于生成 trigger/action 的 type 前缀
 */
export const projectNamespace = "fanfanlo/javajs/v1/project/components/"
